// React Dependiencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';

// Internal Dependencies
import MText from './MText';
import { IsEmpty, IsFunction } from '../../common/checks';
import Colours from '../../styles/colours';

const MButton = (props) => {
  const onBtnClick = () => {
    if (props.type === 'button') {
      props.onClick();
    }
  };
  return (
    <Button
      variant={props.variant}
      className={props.className}
      onClick={onBtnClick}
      style={{ backgroundColor: props.colour, textTransform: 'none', ...props.style }}
      disabled={props.disabled}
      type={props.type}
      disableElevation={props.disableElevation}
      startIcon={!IsEmpty(props.startIcon) ? IsFunction(props.startIcon) : undefined}
      endIcon={!IsEmpty(props.endIcon) ? IsFunction(props.endIcon) : undefined}
    >
      {!IsEmpty(props.icon) && props.icon()}
      <MText size={props.textSize} colour={props.textColour} style={props.textStyle} text={props.text} />
    </Button>
  );
};

MButton.propTypes = {
  className:        PropTypes.string,
  colour:           PropTypes.string,
  onClick:          PropTypes.func.isRequired,
  icon:             PropTypes.func,
  text:             PropTypes.string,
  disabled:         PropTypes.bool,
  disableElevation: PropTypes.bool,
  textSize:         PropTypes.number,
  textColour:       PropTypes.string,
  style:            PropTypes.shape({}),
  type:             PropTypes.oneOf(['button', 'submit', 'reset']),
  variant:          PropTypes.oneOf(['text', 'outlined', 'contained']),
  textStyle:        PropTypes.shape({}),
  startIcon:        PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  endIcon:          PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
};

MButton.defaultProps = {
  text:             '',
  colour:           Colours.White,
  textSize:         13,
  disabled:         false,
  disableElevation: false,
  className:        '',
  textColour:       '',
  style:            {},
  type:             'button',
  icon:             null,
  textStyle:        {},
  variant:          'contained',
  startIcon:        null,
  endIcon:          null,
};

export default MButton;
